<template>
  <div ref="modalUpgrade" class="modal dark-modal w-auto" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-center" role="document">
      <div class="modal-content">
        <!-- <div class="modal-header bg-dark">
          <h5 class="modal-title fw-bold">
            Save Big with Indiefy PRO Upgrade!
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true" class="text-white">&times;</span>
          </button>
        </div> -->
        <div class="modal-body bg-dark">
          <div class="text-center h1 mt-1">
            {{ productTitle }}
          </div>
          <div class="row mt-4 mb-2">
            <div class="col-6">
              <div class="h3 mb-1 pricing-title">{{ $t('basic_price') }}</div>
              <div class="basic-price fw-bold">
                ${{ basicCost }}
              </div>
            </div>
            <div class="col-6">
              <div class="h3 mb-0 pricing-title">{{ $t('pro_price') }}</div>
              <div class="pro-price fw-bold">
                ${{ proCost }}
              </div>
            </div>
          </div>
          <p class="mt-3 mb-0">
            {{ $t('upgrade_pro_comparison') }}
          </p>
        </div>
        <div class="modal-footer bg-dark">
          <button type="button" class="btn btn-light w-50" data-dismiss="modal" @click="basicCallback()">
            {{ $t('continue_as_basic') }}
          </button>
          <button type="button" class="btn btn-gradient w-50" data-dismiss="modal" @click="proCallback()">
            {{ $t('upgrade_to_pro') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PriceComparisonModal',
  data () {
    return {
      user: {},
      productTitle: '',
      basicCallback: null,
      proCallback: null,
      basicCost: '',
      proCost: ''
    }
  },
  methods: {
  },
  created: function () {
    this.user = this.$user

    this.$eventBus.$on('showPriceComparison', (data) => {
      this.basicCallback = data.basicCallback
      this.proCallback = data.proCallback
      this.basicCost = data.basicCost
      this.proCost = data.proCost
      this.productTitle = data.productTitle

      window.$(this.$refs.modalUpgrade).modal('show')
    })
  }
}
</script>

<style scoped>
.modal-body {
  border-radius: 4px 4px 0 0;
}

.pricing-title {
  border: 2px solid white;
  display: inline-block;
  padding: 3px 10px;
  border-radius: 3px;
}

.basic-price {
  font-size: 25px;
}
.pro-price {
  font-size: 45px;
}
</style>



// WEBPACK FOOTER //
// src/components/PriceComparisonModal.vue